module.exports = __webpack_public_path__ + "static/media/Local_QR_Code.a12ecfcb.png";